import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { fromPromise } from "rxjs/observable/fromPromise";
import { map, tap, catchError } from "rxjs/operators";
import { of } from "rxjs/observable/of";
import { Amplify, Auth } from "aws-amplify";
import { environment } from "./../../../../environments/environment";
import { GetInSiteMeterResponse } from "../../data/models/get-in-site-meters-response";
import { LoginApi } from "../../api/login.api";
import { AlertMessage } from "../../constants/messages/alert-message";
import { SessionInfoSingleton } from "../../data/singleton/session-info.singleton";
import { Const } from "../../data/models/const";

// 参考　https://qiita.com/daikiojm/items/18f718df07c28965b7b3#authservice
@Injectable()
export class AuthService {
  public loggedIn: BehaviorSubject<boolean>;
  private login_id: string;

  // ここにidトークン持たせるのではなく、認証処理だけ別で切りだしたサービス（loginはそこを呼び出す）を定義
  // そこに持たせつ（Ingectable）

  /**
   * コンストラクタ
   */
  constructor(
    private router: Router,
    private loginApi: LoginApi,
    private sessionInfoSingleton: SessionInfoSingleton
  ) {
    Amplify.configure(environment.amplify.Auth);
    this.loggedIn = new BehaviorSubject<boolean>(false);
  }

  /**
   * ログイン
   * @param login_id
   * @param password
   * @returns
   */
  public signIn(login_id: string, password: string): Observable<any> {
    this.login_id = login_id;
    // 最終操作の更新
    this.sessionInfoSingleton.updateLastOperationDatetime();
    return fromPromise(Auth.signIn(login_id, password)).pipe(
      tap(() => this.loggedIn.next(true))
    );
  }

  /**
   * ログイン状態の監視
   * @returns
   */
  public isAuthenticated(): Observable<boolean> {
    return fromPromise(Auth.currentAuthenticatedUser()).pipe(
      map((result) => {
        this.loggedIn.next(true);
        return true;
      }),
      catchError((error) => {
        this.loggedIn.next(false);
        return of(false);
      })
    );
  }

  /**
   * IDトークンの取得
   * @returns
   */
  public getIdToken(): Observable<any> {
    return fromPromise(Auth.currentSession()).pipe(
      map((result) => {
        const idToken = result.getIdToken().getJwtToken();
        // シングルトンにも格納しておく
        this.sessionInfoSingleton.setIdToken(idToken);
        return idToken;
      }),
      catchError((error) => {
        return null;
      })
    );
  }

  /**
   * ログアウト
   */
  public signOut() {
    this.loginLogging("0");
    fromPromise(Auth.signOut()).subscribe((result) => {
      localStorage.clear();
      Const.release();
      this.loggedIn.next(false);
      this.router.navigate(["/login"]);
    });
  }

  /**
   * ログイン・ログアウトのログ記録APIをコールする
   * @param type：0=ログアウト、1=ログイン
   */
  public loginLogging(type: string) {
    try {
      this.loginApi
        .recordingLoginLogoutLog(this.login_id, type)
        .subscribe((response: GetInSiteMeterResponse) => {});
    } catch (error) {
      console.error(error);
      alert(AlertMessage.UNEXPECTED_ERROR_MESSAGE);
    }
  }
}
